(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["st-sticky-buy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('st-sticky-buy')) {
  customElements.define('st-sticky-buy', class extends HTMLElement {
    connectedCallback() {
      this.root = document.getElementById('MainProduct-' + this.dataset.section);
      if (!this.root) return;
      this.button = this.querySelector('button');
      this.sync = () => {
        const native = this.root.querySelector('product-form button[name="add"]');
        if (!native) { this.hidden = true; return; }
        const price = this.root.querySelector('[id^="price-"] .price--on-sale .price-item--sale') || this.root.querySelector('[id^="price-"] .price__regular .price-item--regular');
        const options = [...this.root.querySelectorAll('variant-selects input:checked, variant-selects select')].map(e => e.value).filter(Boolean);
        this.querySelector('.st-sticky-buy__selection').textContent = options.join(' / ');
        this.querySelector('.st-sticky-buy__price').textContent = price?.textContent.trim() || '';
        this.button.disabled = native.disabled || native.getAttribute('aria-disabled') === 'true';
        this.button.textContent = native.querySelector('span')?.textContent.trim() || native.textContent.trim();
      };
      this.button.addEventListener('click', () => {
        const native = this.root.querySelector('product-form button[name="add"]');
        if (native && !native.disabled) native.click();
      });
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.root, {childList:true,subtree:true,attributes:true,attributeFilter:['disabled','aria-disabled']});
      const native = this.root.querySelector('product-form button[name="add"]');
      if (native) {
        this.intersection = new IntersectionObserver(entries => {
          this.hidden = entries[0].isIntersecting;
        }, {threshold:0.1});
        this.intersection.observe(native);
      }
      this.sync();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.intersection?.disconnect(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
